import { ISpeechAudiogram } from 'gen/ApiClient';

export const calculateIcaImprovement = (aided: ISpeechAudiogram | undefined, unaided: ISpeechAudiogram | undefined) => {
	if (aided === undefined || unaided === undefined) {
		return 0;
	} else {
		return Math.round(aided.icaScore - unaided.icaScore);
	}
};
